module.exports = __webpack_public_path__ + "static/media/de.c45d5a4b.svg";